module.exports = __webpack_public_path__ + "static/media/icon_borrar_list.d1d04686.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_borrar_list.svg
// module id = 325
// module chunks = 0